(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  document.querySelectorAll('[data-ann-close]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var bar = btn.closest('.ann-bar');
      if (!bar) return;
      bar.style.overflow   = 'hidden';
      bar.style.maxHeight  = bar.offsetHeight + 'px';
      bar.style.transition = 'max-height 0.3s ease, padding 0.3s ease, opacity 0.2s ease';
      requestAnimationFrame(function() {
        bar.style.maxHeight     = '0';
        bar.style.paddingTop    = '0';
        bar.style.paddingBottom = '0';
        bar.style.opacity       = '0';
      });
      setTimeout(function() { bar.remove(); }, 350);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /*
   * _pendingQty acumula cambios de cantidad de múltiples ítems entre disparos.
   * Un solo timer compartido extiende la ventana cada vez que llega un nuevo cambio.
   * Al dispararse, todos los cambios se aplican secuencialmente y hay un único refresh.
   */
  var _pendingQty  = {};
  var _batchTimer  = null;

  document.addEventListener('change', function(e) {
    var input = e.target;
    if (!input.matches('.cart-drawer__qty-input')) return;

    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 1) { input.value = 1; return; }

    var line = Number(input.dataset.line);
    if (!line) return;

    _pendingQty[line] = qty;

    /* Pulso en el precio del ítem tocado + subtotal */
    input.closest('.cart-drawer__item')?.querySelector('.cart-drawer__item-price')
      ?.classList.add('is-updating');
    document.querySelector('.cart-drawer__subtotal-price')?.classList.add('is-updating');

    /* Extender la ventana de batching con cada nueva acción */
    clearTimeout(_batchTimer);
    _batchTimer = setTimeout(async function() {
      var snapshot = _pendingQty;
      _pendingQty  = {};
      try {
        for (var l in snapshot) {
          await window.ShN.Cart.change(Number(l), snapshot[l]);
        }
        await window.ShN.CartDrawer.refresh();
      } catch (_) {
        document.querySelectorAll('.cart-drawer__item-price.is-updating, .cart-drawer__subtotal-price.is-updating')
          .forEach(function(el) { el.classList.remove('is-updating'); });
        window.ShN.Toast.show(window.ShN_i18n.genericError);
      }
    }, 500);
  });

  /*
   * Batch removes: la animación arranca al instante en cada click para dar
   * feedback inmediato. Un timer de 300 ms agrupa todos los removes del
   * mismo "ráfaga". Al dispararse: espera a que TODAS las animaciones
   * terminen (Promise.all), captura y vuelca cambios de cantidad pendientes,
   * y elimina los ítems en orden descendente de línea para evitar que los
   * índices se desplacen entre llamadas.
   */
  var _pendingRemovals = [];
  var _removeTimer     = null;

  document.addEventListener('click', function(e) {
    var removeBtn = e.target.closest('[data-drawer-remove]');
    if (!removeBtn || removeBtn.disabled) return;
    var line = Number(removeBtn.dataset.line);
    if (!line) return;

    removeBtn.disabled = true;

    document.querySelector('.cart-drawer__subtotal-price')?.classList.add('is-updating');

    /* Cancelar el timer de cantidades AHORA para que no dispare un refresh
       mientras las animaciones de borrado están en vuelo */
    clearTimeout(_batchTimer);
    _batchTimer = null;

    var item        = removeBtn.closest('.cart-drawer__item');
    var animPromise = _animateRemoveItem(item);
    _pendingRemovals.push({ line: line, item: item, animPromise: animPromise });

    clearTimeout(_removeTimer);
    _removeTimer = setTimeout(async function() {
      var removals = _pendingRemovals.slice();
      _pendingRemovals = [];

      /* Cancelar también cualquier timer de qty que haya surgido entre clicks
         y capturar lo que se haya acumulado */
      clearTimeout(_batchTimer);
      _batchTimer = null;
      var qtySnapshot = _pendingQty;
      _pendingQty = {};
      removals.forEach(function(r) { delete qtySnapshot[r.line]; });

      /* Saber si se van a borrar TODOS los ítems antes de que empiece el API */
      var totalItems = document.querySelectorAll('.cart-drawer__item').length;
      var cartWillBeEmpty = removals.length >= totalItems;

      /* Esperar a que todas las animaciones concurrentes terminen */
      await Promise.all(removals.map(function(r) { return r.animPromise; }));

      try {
        /* Aplicar cambios de cantidad de ítems que NO se están borrando */
        for (var l in qtySnapshot) {
          await window.ShN.Cart.change(Number(l), qtySnapshot[l]);
        }
        /* Borrar de mayor a menor índice para que los índices no se desplacen */
        removals.sort(function(a, b) { return b.line - a.line; });
        for (var i = 0; i < removals.length; i++) {
          await window.ShN.Cart.change(removals[i].line, 0);
        }
        /* Si el carrito quedará vacío, fade-out del footer antes de reemplazar el DOM */
        if (cartWillBeEmpty) {
          var foot = document.querySelector('.cart-drawer__foot');
          if (foot) {
            foot.style.transition = 'opacity 0.2s ease';
            foot.style.opacity    = '0';
            await new Promise(function(r) { setTimeout(r, 200); });
          }
        }
        await window.ShN.CartDrawer.refresh();
        var n = removals.length;
        window.ShN.Toast.show(n === 1 ? window.ShN_i18n.itemRemoved : window.ShN_i18n.itemsRemovedTemplate.replace('[count]', n));
      } catch (_) {
        removals.forEach(function(r) {
          if (r.item) r.item.classList.remove('is-removing');
        });
        window.ShN.Toast.show(window.ShN_i18n.genericError);
      }
    }, 300);
  });

  function _animateRemoveItem(item) {
    if (!item) return Promise.resolve();
    return new Promise(function(resolve) {
      var h = item.offsetHeight;
      item.classList.add('is-removing');
      item.style.transition = 'opacity 0.22s ease, transform 0.22s ease';
      item.style.opacity    = '0';
      item.style.transform  = 'translateX(18px)';
      setTimeout(function() {
        item.style.height = h + 'px';
        item.offsetHeight;
        item.style.transition        = 'height 0.25s ease, padding 0.25s ease, border-width 0.25s ease';
        item.style.height            = '0';
        item.style.paddingTop        = '0';
        item.style.paddingBottom     = '0';
        item.style.borderBottomWidth = '0';
        setTimeout(resolve, 260);
      }, 200);
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-addresses"]) return;
  try {
    
  (function() {
    var newToggle = document.getElementById('AddressNewToggle');
    var newForm   = document.getElementById('AddressNewForm');
    var newCancel = document.getElementById('AddressNewCancel');

    if (newToggle && newForm) {
      newToggle.addEventListener('click', function() {
        newForm.hidden = !newForm.hidden;
      });
    }
    if (newCancel && newForm) {
      newCancel.addEventListener('click', function() { newForm.hidden = true; });
    }

    document.querySelectorAll('.addr-edit-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var targetId = btn.getAttribute('data-target');
        var form = document.getElementById(targetId);
        if (form) form.hidden = !form.hidden;
      });
    });

    document.querySelectorAll('[data-target].addr-cancel-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var targetId = btn.getAttribute('data-target');
        var form = document.getElementById(targetId);
        if (form) form.hidden = true;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    /* ── Scroll shadow + hide on scroll down / show on scroll up ──
       The header follows the finger 1:1 both ways: it slides away while
       scrolling down and slides back while scrolling up. `--header-offset` exposes
       the visible header height so sticky sidebars can sit below it. */
    var header = document.getElementById('site-header');
    if (!header) return;
    var bar  = header.closest('.shopify-section') || header;
    var root = document.documentElement;
    bar.classList.add('site-header-bar');

    var lastY = window.scrollY;
    var offset = 0;
    var ticking = false;
    var settleTimer = null;

    function apply(snap) {
      bar.classList.toggle('site-header-bar--snap', snap);
      bar.style.top = offset ? -offset + 'px' : '';
      root.style.setProperty('--header-offset', (bar.offsetHeight - offset) + 'px');
    }

    // Don't hide while a header menu/dropdown is open
    function busy() {
      return document.body.style.overflow === 'hidden' ||
             header.querySelector('[aria-expanded="true"]');
    }

    function update() {
      ticking = false;
      // Clamp so iOS rubber-band bounces at either end don't count as scrolls
      var maxY = document.documentElement.scrollHeight - window.innerHeight;
      var y = Math.min(Math.max(window.scrollY, 0), Math.max(maxY, 0));
      var dy = y - lastY;
      lastY = y;
      header.classList.toggle('scrolled', y > 10);
      if (!dy || busy()) return;

      var h = bar.offsetHeight;
      var next = Math.min(h, Math.max(0, offset + dy));
      if (next === offset) return;
      offset = next;
      apply(false);

      // If the finger stops with the header half-hidden, finish the move
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function() {
        if (offset > 0 && offset < h) {
          offset = offset > h / 2 ? h : 0;
          apply(true);
        }
      }, 160);
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    window.addEventListener('resize', function() { apply(false); });
    // Bring the header back on demand (e.g. after adding to cart, so the
    // cart icon's cue is visible even if the shopper had scrolled down)
    document.addEventListener('header:reveal', function() {
      if (!offset) return;
      offset = 0;
      apply(true);
    });
    apply(false);
  })();

  /* ── Market/language dropdown ── */
  (function() {
    var marketBtn   = document.getElementById('market-drop-btn');
    var marketPanel = document.getElementById('market-drop-panel');
    if (!marketBtn || !marketPanel) return;

    var marketForm    = document.getElementById('market-localization-form');
    var countryInput  = document.getElementById('market-country-code');
    var localeInput   = document.getElementById('market-locale-code');
    var options       = marketPanel.querySelectorAll('.market-drop-option');

    function positionMarketPanel() {
      var r = marketBtn.getBoundingClientRect();
      marketPanel.style.top   = (r.bottom + 8) + 'px';
      marketPanel.style.right = (document.documentElement.clientWidth - r.right) + 'px';
    }

    function openMarketPanel() {
      window.ShN.Overlays.opened('market-panel', closeMarketPanel);
      positionMarketPanel();
      marketPanel.hidden = false;
      marketBtn.setAttribute('aria-expanded', 'true');
    }

    function closeMarketPanel() {
      window.ShN.Overlays.closed('market-panel');
      marketPanel.hidden = true;
      marketBtn.setAttribute('aria-expanded', 'false');
    }

    marketBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      marketPanel.hidden ? openMarketPanel() : closeMarketPanel();
    });

    document.addEventListener('click', function(e) {
      if (!marketPanel.hidden && !marketPanel.contains(e.target) && e.target !== marketBtn) closeMarketPanel();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !marketPanel.hidden) { closeMarketPanel(); marketBtn.focus(); }
    });

    marketPanel.addEventListener('click', function(e) { e.stopPropagation(); });

    for (var i = 0; i < options.length; i++) {
      options[i].addEventListener('click', async function() {
        if (this.classList.contains('is-active')) {
          closeMarketPanel();
          return;
        }
        countryInput.value = this.dataset.country;
        localeInput.value  = this.dataset.locale;
        if (window.ShN && window.ShN.MarketCart) {
          await window.ShN.MarketCart.snapshotBeforeLeaving(document.body.dataset.market);
        }
        marketForm.submit();
      });
    }
  })();

  /* ── Market/language selector — mobile drawer ── */
  (function() {
    var toggle = document.getElementById('mobile-market-toggle');
    var list   = document.getElementById('mobile-market-list');
    if (!toggle || !list) return;

    var mobileForm    = document.getElementById('mobile-market-form');
    var countryInput  = document.getElementById('mobile-market-country-code');
    var localeInput   = document.getElementById('mobile-market-locale-code');
    var options       = list.querySelectorAll('.market-drop-option');

    toggle.addEventListener('click', function() {
      var isOpen = !list.hidden;
      list.hidden = isOpen;
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });

    for (var i = 0; i < options.length; i++) {
      options[i].addEventListener('click', async function() {
        if (this.classList.contains('is-active')) return;
        countryInput.value = this.dataset.country;
        localeInput.value  = this.dataset.locale;
        if (window.ShN && window.ShN.MarketCart) {
          await window.ShN.MarketCart.snapshotBeforeLeaving(document.body.dataset.market);
        }
        mobileForm.submit();
      });
    }
  })();

  /* ── Account: the native <shopify-account> popover closes itself on outside
     clicks, but our overlays don't know about it — close them when it opens. ── */
  (function() {
    var account = document.querySelector('.site-nav shopify-account');
    if (!account) return;
    account.addEventListener('click', function() { window.ShN.Overlays.closeAll(); });
  })();

  /* ── Hamburger -> X animation ── */
  (function() {
    var mobileMenu = document.getElementById('mobile-menu');
    var hamburger  = document.querySelector('[data-drawer-open="mobile-menu"]');
    if (!mobileMenu || !hamburger) return;
    new MutationObserver(function() {
      var isOpen = mobileMenu.classList.contains('is-open');
      hamburger.classList.toggle('is-active', isOpen);
      hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      hamburger.setAttribute('aria-label', isOpen ? hamburger.dataset.labelClose : hamburger.dataset.labelOpen);
    }).observe(mobileMenu, { attributes: true, attributeFilter: ['class'] });
  })();

  /* ── Desktop Search ── */
  (function() {
    var desktopBtn     = document.querySelector('.site-nav__icon-btn--search.hide-mobile');
    var desktopPanel   = document.getElementById('desktop-search-panel');
    var desktopClose   = document.getElementById('desktop-search-close');
    var desktopBackdrop = document.getElementById('desktop-search-backdrop');
    var desktopInput   = document.getElementById('desktop-search-input');
    var desktopClear   = document.getElementById('desktop-search-clear');

    if (!desktopBtn || !desktopPanel) return;

    var SEARCH_DURATION = 350;

    function isDesktopSearchOpen() {
      return desktopPanel.getAttribute('aria-hidden') === 'false';
    }

    function openDesktopSearch() {
      if (isDesktopSearchOpen()) return;
      window.ShN.Overlays.opened('desktop-search', function() { closeDesktopSearch(false); });
      desktopPanel.setAttribute('aria-hidden', 'false');
      window.ShN.ScrollLock.lock();
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          desktopPanel.classList.add('is-open');
          if (desktopInput) desktopInput.focus();
        });
      });
    }

    // `restoreFocus` is false when another overlay is replacing this one
    function closeDesktopSearch(restoreFocus) {
      if (!isDesktopSearchOpen()) return;
      window.ShN.Overlays.closed('desktop-search');
      desktopPanel.classList.remove('is-open');
      window.ShN.ScrollLock.unlock();
      if (restoreFocus !== false) desktopBtn.focus();
      setTimeout(function() {
        if (!desktopPanel.classList.contains('is-open')) {
          desktopPanel.setAttribute('aria-hidden', 'true');
        }
      }, SEARCH_DURATION);
    }

    desktopBtn.addEventListener('click', openDesktopSearch);
    if (desktopClose) desktopClose.addEventListener('click', closeDesktopSearch);
    if (desktopBackdrop) desktopBackdrop.addEventListener('click', closeDesktopSearch);

    if (desktopInput && desktopClear) {
      desktopInput.addEventListener('input', function() {
        desktopClear.hidden = desktopInput.value.length === 0;
      });
      desktopClear.addEventListener('click', function() {
        desktopInput.value = '';
        desktopClear.hidden = true;
        desktopInput.focus();
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isDesktopSearchOpen()) {
        closeDesktopSearch();
      }
    });
  })();

  /* ── Mobile Search ── */
  (function() {
    var searchBtn     = document.getElementById('mobile-search-btn');
    var searchPanel   = document.getElementById('mobile-search-panel');
    var searchClose   = document.getElementById('mobile-search-close');
    var searchBackdrop = document.getElementById('mobile-search-backdrop');
    var searchInput   = document.getElementById('mobile-search-input');
    var searchClear   = document.getElementById('mobile-search-clear');

    if (!searchBtn || !searchPanel) return;

    function isSearchOpen() {
      return searchPanel.getAttribute('aria-hidden') === 'false';
    }

    function openSearch() {
      if (isSearchOpen()) return;
      window.ShN.Overlays.opened('mobile-search', function() { closeSearch(false); });
      searchPanel.setAttribute('aria-hidden', 'false');
      window.ShN.ScrollLock.lock();
      if (searchInput) {
        setTimeout(function() { searchInput.focus(); }, 320);
      }
    }

    // `restoreFocus` is false when another overlay is replacing this one
    function closeSearch(restoreFocus) {
      if (!isSearchOpen()) return;
      window.ShN.Overlays.closed('mobile-search');
      searchPanel.setAttribute('aria-hidden', 'true');
      window.ShN.ScrollLock.unlock();
      if (restoreFocus !== false) searchBtn.focus();
    }

    searchBtn.addEventListener('click', openSearch);
    if (searchClose) searchClose.addEventListener('click', closeSearch);
    if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearch);

    if (searchInput && searchClear) {
      searchInput.addEventListener('input', function() {
        searchClear.hidden = searchInput.value.length === 0;
      });
      searchClear.addEventListener('click', function() {
        searchInput.value = '';
        searchClear.hidden = true;
        searchInput.focus();
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isSearchOpen()) {
        closeSearch();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-404"]) return;
  try {
    
  (function () {
    var wrap  = document.querySelector('.s-404__field-wrap');
    if (!wrap) return;
    var input = wrap.querySelector('.s-404__input');
    var clear = wrap.querySelector('.s-404__clear');
    if (!input || !clear) return;

    function syncClear() {
      if (input.value.length > 0) {
        clear.removeAttribute('hidden');
      } else {
        clear.setAttribute('hidden', '');
      }
    }

    syncClear();
    input.addEventListener('input', syncClear);
    clear.addEventListener('click', function () {
      input.value = '';
      input.focus();
      syncClear();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('cart-form');
    if (!form) return;

    /* ── Cart API (sin form.submit — evita 403 por falta de authenticity_token) ── */
    async function _apiChange(line, qty) {
      var api = window.ShN && window.ShN.Cart;
      if (api) {
        await api.change(line, qty);
      } else {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: qty }),
        });
      }
    }

    /* ── Batch qty — igual que el drawer ── */
    var _pendingQty  = {};
    var _batchTimer  = null;

    function _scheduleQtyUpdate(line, val, itemEl) {
      _pendingQty[line] = val;

      var linePrice = itemEl && itemEl.querySelector('.cart-item__line');
      if (linePrice) linePrice.classList.add('is-updating');
      document.querySelectorAll('.cart-summary__sub-price, .cart-summary__total-price')
        .forEach(function(el) { el.classList.add('is-updating'); });

      clearTimeout(_batchTimer);
      _batchTimer = setTimeout(async function() {
        var snapshot = _pendingQty;
        _pendingQty  = {};
        try {
          for (var l in snapshot) { await _apiChange(Number(l), snapshot[l]); }
          window.location.reload();
        } catch (_) {
          document.querySelectorAll('.is-updating')
            .forEach(function(el) { el.classList.remove('is-updating'); });
          if (window.ShN && window.ShN.Toast) window.ShN.Toast.show(window.ShN_i18n.genericError);
        }
      }, 500);
    }

    form.querySelectorAll('.cart-qty__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir   = parseInt(this.dataset.dir, 10);
        var input = this.closest('.cart-qty').querySelector('.cart-qty__input');
        var val   = Math.max(0, parseInt(input.value, 10) + dir);
        var line  = Number(input.dataset.line);
        input.value = val;
        if (!line) return;
        _scheduleQtyUpdate(line, val, this.closest('.cart-item'));
      });
    });

    form.querySelectorAll('.cart-qty__input').forEach(function (input) {
      input.addEventListener('change', function () {
        var val  = Math.max(0, parseInt(this.value, 10) || 0);
        var line = Number(this.dataset.line);
        this.value = val;
        if (!line) return;
        _scheduleQtyUpdate(line, val, this.closest('.cart-item'));
      });
    });

    /* ── Batch removes — igual que el drawer ── */
    var _pendingRemovals = [];
    var _removeTimer     = null;

    document.querySelectorAll('.cart-item__remove-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var line = Number(this.dataset.line);
        if (!line) return;

        btn.disabled = true;

        document.querySelectorAll('.cart-summary__sub-price, .cart-summary__total-price')
          .forEach(function(el) { el.classList.add('is-updating'); });

        /* Cancelar timer de qty al instante para no interferir con las animaciones */
        clearTimeout(_batchTimer);
        _batchTimer = null;

        var item        = this.closest('.cart-item');
        var animPromise = _animateRemoveItem(item);
        _pendingRemovals.push({ line: line, item: item, animPromise: animPromise });

        clearTimeout(_removeTimer);
        _removeTimer = setTimeout(async function() {
          var removals = _pendingRemovals.slice();
          _pendingRemovals = [];

          /* Capturar qty pendientes en el momento de disparar (no en el click) */
          clearTimeout(_batchTimer);
          _batchTimer = null;
          var qtySnapshot = _pendingQty;
          _pendingQty = {};
          removals.forEach(function(r) { delete qtySnapshot[r.line]; });

          /* Esperar a que todas las animaciones concurrentes terminen */
          await Promise.all(removals.map(function(r) { return r.animPromise; }));

          try {
            for (var l in qtySnapshot) { await _apiChange(Number(l), qtySnapshot[l]); }
            /* Borrar de mayor a menor índice — evita drift de índices */
            removals.sort(function(a, b) { return b.line - a.line; });
            for (var i = 0; i < removals.length; i++) {
              await _apiChange(removals[i].line, 0);
            }
            window.location.reload();
          } catch (_) {
            removals.forEach(function(r) {
              if (r.item) r.item.classList.remove('is-removing');
            });
            if (window.ShN && window.ShN.Toast) window.ShN.Toast.show(window.ShN_i18n.genericError);
          }
        }, 300);
      });
    });

    function _animateRemoveItem(item) {
      if (!item) return Promise.resolve();
      return new Promise(function(resolve) {
        var h = item.offsetHeight;
        item.classList.add('is-removing');
        item.style.transition = 'opacity 0.22s ease, transform 0.22s ease';
        item.style.opacity    = '0';
        item.style.transform  = 'translateX(18px)';
        setTimeout(function() {
          item.style.height = h + 'px';
          item.offsetHeight;
          item.style.transition        = 'height 0.25s ease, padding 0.25s ease, border-width 0.25s ease';
          item.style.height            = '0';
          item.style.paddingTop        = '0';
          item.style.paddingBottom     = '0';
          item.style.borderBottomWidth = '0';
          setTimeout(resolve, 260);
        }, 200);
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Sort — preserve active filter params */
    var sortSel = document.getElementById('col-sort');
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        url.searchParams.delete('page');
        window.location = url.toString();
      });
    }

    /* Products per page — backed by alternate templates via the `view` param */
    var PP_VIEW_MAP = { '12': 'per-page-12', '24': '', '36': 'per-page-36', '48': 'per-page-48' };
    document.querySelectorAll('[data-per-page-select] .col-pp__select').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        var suffix = PP_VIEW_MAP[this.value];
        if (suffix) {
          url.searchParams.set('view', suffix);
        } else {
          url.searchParams.delete('view');
        }
        url.searchParams.delete('page');
        window.location = url.toString();
      });
    });

    /* Filter chips and pagination links are rendered by Shopify's own URL
       builders, which may not retain a custom `view` param — carry it over
       explicitly so changing a filter or page doesn't silently reset the
       products-per-page choice back to the default. */
    var activeView = new URL(window.location.href).searchParams.get('view');
    if (activeView) {
      document.querySelectorAll('a.col-tb__chip, a.col-pag__btn').forEach(function (a) {
        var linkUrl = new URL(a.href, window.location.origin);
        if (!linkUrl.searchParams.has('view')) {
          linkUrl.searchParams.set('view', activeView);
          a.href = linkUrl.toString();
        }
      });
    }

    /* Filter panel — collapse/expand */
    document.querySelectorAll('.col-fp__header').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var section = this.closest('.col-fp__section');
        var expanded = this.getAttribute('aria-expanded') === 'true';
        section.classList.toggle('collapsed', expanded);
        this.setAttribute('aria-expanded', !expanded);
      });
    });

    /* Filter form — auto-submit on checkbox change */
    ['col-filter-form', 'col-mobile-filter-form'].forEach(function (id) {
      var form = document.getElementById(id);
      if (!form) return;
      form.querySelectorAll('.col-fp__check').forEach(function (cb) {
        cb.addEventListener('change', function () { form.submit(); });
      });
    });

    /* Mobile bottom sheet */
    var openBtn  = document.getElementById('col-filter-open');
    var closeBtn = document.getElementById('col-filter-close');
    var overlay  = document.getElementById('col-sheet-overlay');
    var sheet    = document.getElementById('col-mobile-sheet');

    function isSheetOpen() { return sheet.classList.contains('open'); }

    function openSheet() {
      if (isSheetOpen()) return;
      window.ShN.Overlays.opened('collection-filters', closeSheet);
      overlay.classList.add('open');
      sheet.classList.add('open');
      sheet.setAttribute('aria-hidden', 'false');
      openBtn && openBtn.setAttribute('aria-expanded', 'true');
      window.ShN.ScrollLock.lock();
    }
    function closeSheet() {
      if (!isSheetOpen()) return;
      window.ShN.Overlays.closed('collection-filters');
      overlay.classList.remove('open');
      sheet.classList.remove('open');
      sheet.setAttribute('aria-hidden', 'true');
      openBtn && openBtn.setAttribute('aria-expanded', 'false');
      window.ShN.ScrollLock.unlock();
    }

    openBtn  && openBtn.addEventListener('click', openSheet);
    closeBtn && closeBtn.addEventListener('click', closeSheet);
    overlay  && overlay.addEventListener('click', closeSheet);

    /* Price range slider */
    document.querySelectorAll('[data-fp-slider]').forEach(function (wrap) {
      var rMin = wrap.querySelector('.col-fp__range--min');
      var rMax = wrap.querySelector('.col-fp__range--max');
      var fill = wrap.querySelector('.col-fp__sl-fill');
      var fp   = parseInt(wrap.dataset.range) || 1;
      var container = wrap.closest('.col-fp__price');
      var lMin = container.querySelector('[data-fp-lmin]');
      var lMax = container.querySelector('[data-fp-lmax]');
      var hMin = container.querySelector('[data-fp-hmin]');
      var hMax = container.querySelector('[data-fp-hmax]');

      function update() {
        var mn = parseInt(rMin.value);
        var mx = parseInt(rMax.value);
        if (mn >= mx) {
          if (this === rMin) { rMin.value = mx - 1; mn = parseInt(rMin.value); }
          else { rMax.value = mn + 1; mx = parseInt(rMax.value); }
        }
        fill.style.left  = (mn / fp * 100) + '%';
        fill.style.width = ((mx - mn) / fp * 100) + '%';
        if (lMin) lMin.textContent = '$' + Math.round(mn / 100);
        if (lMax) lMax.textContent = '$' + Math.round(mx / 100) + ' MXN';
        if (hMin) hMin.value = mn > 0  ? (mn / 100).toFixed(2) : '';
        if (hMax) hMax.value = mx < fp ? (mx / 100).toFixed(2) : '';
      }

      rMin.addEventListener('input', update.bind(rMin));
      rMax.addEventListener('input', update.bind(rMax));
      update.call(rMin);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function(){
    var mainImgEl = document.getElementById('MpdMainImgEl');
    document.querySelectorAll('.mpd-thumb').forEach(function(btn){
      btn.addEventListener('click', function(){
        document.querySelectorAll('.mpd-thumb').forEach(function(b){
          b.classList.remove('active'); b.setAttribute('aria-selected','false');
        });
        btn.classList.add('active'); btn.setAttribute('aria-selected','true');
        if (mainImgEl) {
          mainImgEl.style.opacity = '0';
          setTimeout(function(){
            mainImgEl.src = btn.dataset.src;
            mainImgEl.alt = btn.dataset.alt;
            mainImgEl.style.opacity = '1';
          }, 150);
        }
      });
    });
    var qtyInput = document.getElementById('MpdQtyInput');
    document.querySelectorAll('[data-qty-change]').forEach(function(btn){
      btn.addEventListener('click', function(){
        if (!qtyInput) return;
        var next = Math.max(1, (parseInt(qtyInput.value) || 1) + parseInt(btn.dataset.qtyChange));
        qtyInput.value = next;
      });
    });

    var lightbox         = document.getElementById('MpdLightbox');
    var lightboxImg      = document.getElementById('MpdLightboxImg');
    var lightboxClose    = document.getElementById('MpdLightboxClose');
    var lightboxBackdrop = document.getElementById('MpdLightboxBackdrop');

    function openLightbox() {
      if (!lightbox || !mainImgEl) return;
      lightboxImg.src = mainImgEl.src;
      lightboxImg.alt = mainImgEl.alt;
      lightbox.removeAttribute('hidden');
      window.ShN.ScrollLock.lock();
      requestAnimationFrame(function(){ lightbox.classList.add('is-open'); });
    }
    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      setTimeout(function(){
        lightbox.setAttribute('hidden', '');
        window.ShN.ScrollLock.unlock();
      }, 250);
    }

    var zoomBtn = document.querySelector('[data-mpd-zoom]');
    if (zoomBtn)          zoomBtn.addEventListener('click', openLightbox);
    if (mainImgEl)        mainImgEl.addEventListener('click', openLightbox);
    if (lightboxClose)    lightboxClose.addEventListener('click', closeLightbox);
    if (lightboxBackdrop) lightboxBackdrop.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape') closeLightbox();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (function () {
    /* ── Botón limpiar input ── */
    var wrap  = document.querySelector('.sr-field-wrap');
    if (wrap) {
      var input = wrap.querySelector('.sr-input');
      var clear = wrap.querySelector('.sr-clear');
      if (input && clear) {
        function syncClear() {
          if (input.value.length > 0) {
            clear.removeAttribute('hidden');
          } else {
            clear.setAttribute('hidden', '');
          }
        }
        syncClear();
        input.addEventListener('input', syncClear);
        clear.addEventListener('click', function () {
          input.value = '';
          input.focus();
          syncClear();
        });
      }
    }

    /* ── Select de ordenación ── */
    var sortSelect = document.getElementById('sr-sort');
    if (sortSelect) {
      var pageUrl = new URL(window.location.href);
      var currentSort = pageUrl.searchParams.get('sort_by') || 'relevance';
      sortSelect.value = currentSort;

      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["market-banner"]) return;
  try {
    
  (function() {
    var marketBanner      = document.getElementById('market-banner');
    var unavailableBanner = document.getElementById('unavailable-banner');
    if (!marketBanner && !unavailableBanner) return;

    var US_ZONES = [
      'America/New_York', 'America/Detroit', 'America/Kentucky/Louisville', 'America/Kentucky/Monticello',
      'America/Indiana/Indianapolis', 'America/Indiana/Vincennes', 'America/Indiana/Winamac',
      'America/Indiana/Marengo', 'America/Indiana/Petersburg', 'America/Indiana/Vevay',
      'America/Chicago', 'America/Indiana/Tell_City', 'America/Indiana/Knox', 'America/Menominee',
      'America/North_Dakota/Center', 'America/North_Dakota/New_Salem', 'America/North_Dakota/Beulah',
      'America/Denver', 'America/Boise', 'America/Phoenix', 'America/Los_Angeles',
      'America/Anchorage', 'America/Juneau', 'America/Sitka', 'America/Metlakatla', 'America/Yakutat',
      'America/Nome', 'America/Adak', 'Pacific/Honolulu'
    ];
    var MX_ZONES = [
      'America/Mexico_City', 'America/Cancun', 'America/Merida', 'America/Monterrey',
      'America/Matamoros', 'America/Mazatlan', 'America/Chihuahua', 'America/Ojinaga',
      'America/Hermosillo', 'America/Tijuana', 'America/Bahia_Banderas', 'America/Ciudad_Juarez'
    ];

    var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var detectedCountry = null;
    if (US_ZONES.indexOf(timeZone) !== -1) detectedCountry = 'US';
    if (MX_ZONES.indexOf(timeZone) !== -1) detectedCountry = 'MX';

    if (detectedCountry && marketBanner && detectedCountry === marketBanner.dataset.targetCountry) {
      if (window.localStorage && localStorage.getItem('sheloMarketBannerDismissed') === 'true') return;

      marketBanner.hidden = false;

      var closeBtn  = document.getElementById('market-banner-close');
      var switchBtn = document.getElementById('market-banner-switch');
      var form      = document.getElementById('market-banner-form');

      closeBtn.addEventListener('click', function() {
        marketBanner.hidden = true;
        if (window.localStorage) localStorage.setItem('sheloMarketBannerDismissed', 'true');
      });

      switchBtn.addEventListener('click', function() {
        form.submit();
      });
      return;
    }

    if (!detectedCountry && unavailableBanner) {
      if (window.localStorage && localStorage.getItem('sheloUnavailableBannerDismissed') === 'true') return;

      unavailableBanner.hidden = false;

      var unavailableCloseBtn = document.getElementById('unavailable-banner-close');
      unavailableCloseBtn.addEventListener('click', function() {
        unavailableBanner.hidden = true;
        if (window.localStorage) localStorage.setItem('sheloUnavailableBannerDismissed', 'true');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.pfaq-item__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        var answerId = this.getAttribute('aria-controls');
        var answer   = document.getElementById(answerId);
        this.setAttribute('aria-expanded', !expanded);
        if (expanded) { answer.hidden = true; } else { answer.hidden = false; }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-description"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var bar    = document.querySelector('[data-pd-bar]');
    var outer  = bar && bar.parentNode;
    var tabs   = document.querySelectorAll('.pd-tab');
    var panels = document.querySelectorAll('.pd-tab-panel');

    /* Center the active tab inside the scrollable bar */
    function scrollTabIntoView(tab) {
      if (!bar) return;
      var tabCenter  = tab.offsetLeft + tab.offsetWidth / 2;
      var barCenter  = bar.clientWidth / 2;
      bar.scrollTo({ left: tabCenter - barCenter, behavior: 'smooth' });
    }

    /* Show/hide the right-fade gradient based on scroll position */
    function updateGradient() {
      if (!outer) return;
      var atEnd = bar.scrollLeft >= bar.scrollWidth - bar.clientWidth - 4;
      outer.classList.toggle('at-end', atEnd);
    }

    if (bar) {
      bar.addEventListener('scroll', updateGradient, { passive: true });
      updateGradient();
    }

    /* Tab click: switch panel + scroll tab into view */
    function activateTab(tab, slideDir) {
      var idx = tab.dataset.tabIndex;
      tabs.forEach(function(t){
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      panels.forEach(function(p){ p.classList.remove('active'); });
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');
      var panel = document.querySelector('.pd-tab-panel[data-panel-index="' + idx + '"]');
      if (panel) {
        /* Set slide direction: positive = from right, negative = from left */
        panel.style.setProperty('--pd-slide-from', (slideDir > 0 ? '24px' : '-24px'));
        panel.classList.add('active');
      }
      scrollTabIntoView(tab);
    }

    tabs.forEach(function(tab, i){
      tab.addEventListener('click', function(){
        var prev = document.querySelector('.pd-tab.active');
        var prevIdx = prev ? parseInt(prev.dataset.tabIndex) : 0;
        var dir = parseInt(tab.dataset.tabIndex) - prevIdx;
        activateTab(tab, dir);
      });
    });

    /* On load: scroll first active tab into view (in case it's not at position 0) */
    var activeTab = document.querySelector('.pd-tab.active');
    if (activeTab) scrollTabIntoView(activeTab);

    /* ── Panel swipe (content area) ── */
    var section    = document.querySelector('[data-pd-section]');
    var allTabs    = Array.from(tabs);
    var SWIPE_MIN  = 40; // px horizontal threshold
    var swStartX   = 0;
    var swStartY   = 0;
    var swOnBar    = false;

    if (section) {
      section.addEventListener('touchstart', function(e) {
        swStartX  = e.touches[0].clientX;
        swStartY  = e.touches[0].clientY;
        /* Ignore swipes that start on the scrollable tab bar */
        swOnBar = bar ? bar.contains(e.target) : false;
      }, { passive: true });

      section.addEventListener('touchend', function(e) {
        if (swOnBar) return;
        var dx = swStartX - e.changedTouches[0].clientX;
        var dy = Math.abs(swStartY - e.changedTouches[0].clientY);
        /* Require horizontal intent: dx > threshold AND dx > dy */
        if (Math.abs(dx) < SWIPE_MIN || dy > Math.abs(dx)) return;

        var current = document.querySelector('.pd-tab.active');
        if (!current) return;
        /* Posición en la lista visible, no data-tab-index (hay pestañas ocultas) */
        var curIdx  = allTabs.indexOf(current);
        var nextIdx = curIdx + (dx > 0 ? 1 : -1);
        nextIdx = Math.max(0, Math.min(nextIdx, allTabs.length - 1));
        if (nextIdx !== curIdx) activateTab(allTabs[nextIdx], nextIdx - curIdx);
      }, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-rp-root]');
    if (!root) return;
    if (root.querySelector('.product-card')) return;

    var productId = root.dataset.productId;
    var sectionId = root.dataset.sectionId;
    var limit = 4;

    fetch(
      '/recommendations/products?product_id=' + productId +
      '&limit=' + limit +
      '&section_id=' + sectionId
    )
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('[data-rp-root] .rp-grid');
        if (grid && grid.children.length > 0) {
          root.querySelector('.rp-grid').innerHTML = grid.innerHTML;
          root.removeAttribute('hidden');
        }
      })
      .catch(function() {});
  })();

  } catch(e) { console.error(e); }
})();
})();
